/**
 * PDF evidence pack (MERGE-PLAN §4.4). Zero-dependency, CSP-clean: rather than a
 * new window with inline styles (blocked by `style-src 'self'`) or a PDF library
 * (supply-chain weight), we render the pack into the app DOM and use an
 * `@media print` stylesheet to isolate it, then invoke the browser's print → the
 * user chooses "Save as PDF". Matches Health365's existing print-to-PDF approach.
 *
 * The printable layout lives in EvidencePrintReport.tsx; this just triggers print.
 */
export function printEvidencePack(): void {
  // Give React a tick to have the printable report mounted/visible.
  window.setTimeout(() => window.print(), 50);
}
